// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bej_a bib_ea bib_ke bib_ju bib_sn bib_wl"};